export function Topics(){
    
    return (
        <section className="bg-dark-gray">
            <div className="container">
                <div className="row justify-content-center mb-5 sm-mb-30px">
                    <div className="col-xl-6 col-lg-8 col-md-10 text-center"
                         data-anime={JSON.stringify({
                             "el": "childs",
                             "translateY": [30, 0],
                             "opacity": [0, 1],
                             "duration": 600,
                             "delay": 0,
                             "staggervalue": 300,
                             "easing": "easeOutQuad"
                         })}>
                        <h3 className="text-white mb-0 fw-600">Hogy mi várható a konferencián? Témáink</h3>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-md-4 row-cols-lg-5 justify-content-center g-0"
                     data-anime={JSON.stringify({
                         "el": "childs",
                         "translateY": [15, 0],
                         "opacity": [0, 1],
                         "duration": 300,
                         "delay": 0,
                         "staggervalue": 100,
                         "easing": "easeOutQuad"
                     })}>
                    <TopicBox icon={"/benefitshare/img/icons/vallalati_egeszsegkultura.svg"} title={"Vállalati egészségkultúra"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/noi_perspektiva.svg"} title={"Női perspektíva"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/innovativ_hr.svg"} title={"Innovatív HR-megoldások"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/employer_branding.svg"} title={"Employer branding"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/motivacios_nehezsegek.svg"} title={"Motivációs nehézségek"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/elegedett_munkavallalok.svg"} title={"Elégedett munkavállalók"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/onszervezodes.svg"} title={"Önszerveződés ereje"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/teljesitmenykultura.svg"} title={"Teljesítménykultúra"}></TopicBox>
                    <TopicBox icon={"/benefitshare/img/icons/kerekasztal.svg"} title={"Panelbeszélgetések"}></TopicBox>
                </div>
            </div>
        </section>
    )
}

export function TopicBox({title, icon}) {
    return (
        <div className="col icon-with-text-style-04 transition-inner-all">
            <div
                className="feature-box hover-box h-100 transition dark-hover pt-25 pb-25 xs-p-12 last-paragraph-no-margin overflow-hidden border-color-transparent-on-hover">
                <div className="feature-box-icon"><img src={icon} style={{width:'60px',height:'60px', margin:'15px'}} alt="Ikon" />
                </div>
                <div className="feature-box-content"><span
                    className="d-inline-block text-white fw-600 fs-14 text-uppercase">{title}</span>
                </div>
                <div className="feature-box-overlay bg-base-color"></div>
            </div>
        </div>
    )
}